export default "__VITE_ASSET__BH8w_ihV__"